<template>
  <v-col class="mt-0 pt-0">
    <label class="subtitle-2 text-weight-black">
      Referência:
      <strong
        >{{ productSelected.provider_code
        }}{{ productSelected.reference }}</strong
      >
      <br />
      Material:
      <strong
        >{{ productSelected.material_code }} -
        {{ productSelected.material_name }}</strong
      >
      <br />
      Cor:
      <strong
        >{{ productSelected.color_code }} -
        {{ productSelected.color_name }}</strong
      >
      <br />
      <!-- Fornec.: <strong>{{ productSelected.provider }}</strong> -->
      <!-- <br /> -->
      Grade:
      <strong
        >{{ productSelected.grid[0] }} a
        {{ productSelected.grid[productSelected.grid.length - 1] }}</strong
      >
    </label>
  </v-col>
</template>

<script>
export default {
  props: {
    productSelected: {},
  },
};
</script>
